import { normalizarRut } from "./rut";
import { client } from "./supabase";

// Label de display de un cliente para selectores/dropdowns: muestra el nombre GRANULAR
// "EMPRESA | PRODUCTO" (`clientes.nombre`), con fallback a `empresa` si nombre está null.
// Es SOLO display — la selección/filtro sigue siendo por ID (regla 8). Centraliza el criterio
// para que los dropdowns no vuelvan a divergir (sesión 2026-06-12: distinguir los N productos
// de una misma empresa, ej. "ASTARA | MITSUBISHI" vs "ASTARA | OMODA" en vez de 8 "ASTARA").
export const getClienteLabel = (cliente) => cliente?.nombre || cliente?.empresa || "—";

// Lista de clientes activos para selectors. Sin side effects (no toasts, no throws en data vacía).
// La tabla clientes usa "eliminada" como soft-delete (no tiene columna "habilitado").
export const getClientesActivos = async (pais) => {
  const { data, error } = await client
    .from("clientes")
    .select("id, empresa, nombre, rut")
    .eq("pais", pais)
    .eq("eliminada", false)
    .order("empresa", { ascending: true });
  if (error) throw error;
  return data || [];
};

// Crear cliente con campos mínimos desde el selector inline del modal de vinculación SII.
// A diferencia de saveCliente (que sincroniza contactos relacionales), este insert es plano:
// solo nombre, empresa, rut, pais. eliminada se setea explícitamente a false.
// Guard anti-duplicado por RUT (regla 10.7), mismo patrón que crearProveedor: comparación
// NORMALIZADA en memoria (formatos heterogéneos), scope por país.
// Retorno: éxito → la fila creada (tiene `.id`); duplicado → `{ yaExiste: true, cliente: {...} }`.
export const crearClienteMinimal = async ({ pais, empresa, nombre, rut }) => {
  const rutNuevo = normalizarRut(rut);
  if (rutNuevo) {
    let query = client.from("clientes").select("id, empresa, nombre, rut").not("rut", "is", null);
    if (pais) query = query.eq("pais", pais);
    const { data: existentes, error: errBusca } = await query;
    if (errBusca) throw errBusca;
    const dup = (existentes || []).find((c) => normalizarRut(c.rut) === rutNuevo);
    if (dup) return { yaExiste: true, cliente: dup };
  }
  const { data, error } = await client
    .from("clientes")
    .insert({ pais, empresa, nombre: nombre || empresa, rut: rut || null, eliminada: false })
    .select()
    .single();
  if (error) throw error;
  return data;
};
